import React, {Fragment} from 'react';
import {Outlet} from "react-router-dom";
import AppNavbar from "../../components/common/AppNavbar";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AccountProfile from "../../components/account/AccountProfile";
import {useAuth} from "../../context/AuthProvider";

const AccountPage = () => {
    const {user} = useAuth();
    return (
        <Fragment>
            <AppNavbar/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    py: 2
                }}
            >
                <Container component="main" maxWidth="lg">
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            lg={4}
                            md={6}
                            xs={12}
                        >
                            <AccountProfile user={user} />
                        </Grid>
                        <Grid
                            item
                            lg={8}
                            md={6}
                            xs={12}
                        >
                            <Outlet />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Fragment>
    );
};

export default AccountPage;